import { Monitor, Radio, SquareStack, Tv } from "lucide-react";
import type { PlatformCategory, PlatformDefinition, PlatformId } from "@handlequest/shared";

interface PlatformSelectorProps {
  platforms: PlatformDefinition[];
  selected: PlatformId[];
  onToggle: (platform: PlatformId) => void;
  onSelectAll: () => void;
}

const categoryLabels: Record<PlatformCategory, string> = {
  console: "Console",
  pc: "PC gaming",
  sandbox: "Sandbox",
  streaming: "Streaming"
};

const categoryIcons = {
  console: Tv,
  pc: Monitor,
  sandbox: SquareStack,
  streaming: Radio
};

export function PlatformSelector({ platforms, selected, onToggle, onSelectAll }: PlatformSelectorProps) {
  const categories = Array.from(new Set(platforms.map((platform) => platform.category)));

  return (
    <section className="platform-picker" aria-label="Platform selection">
      <div className="platform-picker-head">
        <div>
          <p className="eyebrow">Platform set</p>
          <h2>Choose the surfaces to scan.</h2>
        </div>
        <button className="ghost-button" type="button" onClick={onSelectAll}>All platforms</button>
      </div>
      <div className="platform-groups">
        {categories.map((category) => {
          const Icon = categoryIcons[category];
          return (
            <div className="platform-group" key={category}>
              <div className="group-label"><Icon aria-hidden="true" />{categoryLabels[category]}</div>
              <div className="platform-list">
                {platforms.filter((platform) => platform.category === category).map((platform) => {
                  const isSelected = selected.includes(platform.id);
                  return (
                    <button
                      className="platform-tile"
                      type="button"
                      key={platform.id}
                      aria-pressed={isSelected}
                      onClick={() => onToggle(platform.id)}
                    >
                      <span className="platform-mark">{platform.shortName}</span>
                      <span>
                        <strong>{platform.name}</strong>
                        <small>{platform.requiresSecret ? "Secret-backed" : "Live now"}</small>
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

